import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { HospitalityLandingPage } from './mainView';
import { theme } from './theme';
// Initialize Firebase for landing page analytics
const firebaseConfig = {
    apiKey: 'AIzaSyBvn-TFcfP3xPP0YUurC0aN70QWZOT-HTA',
    authDomain: 'stanorai-outreach.firebaseapp.com',
    projectId: 'stanorai-outreach',
    storageBucket: 'stanorai-outreach.appspot.com',
    messagingSenderId: '962525627369',
    appId: '1:962525627369:web:812ee588acef8fccdf4178',
    measurementId: 'G-W32Q6M4S6P'
};
const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(HospitalityLandingPage, {})] }) }));
